<template>
  <div v-show="showPray" class="zoom">
    <mdd-paso-subtitulo :subtitle="t.mdd.profundiza" :help="step.help[2]" />

    <!-- profundiza -->
    <div class="pt-2">
      <strong
        class="font-italic cyan--text text-uppercase"
        v-text="lectio.fraseReflex"
      ></strong>
      <div v-html="lectio.txtReflex"></div>
      <strong class="font-italic cyan--text">{{ t.app.ora }}</strong>
      <div v-html="lectio.oraDia"></div>
    </div>

    <slot></slot>
  </div>
</template>

<script>
import MddPasoSubtitulo from "./MddPasoSubtitulo";

export default {
  name: "mdd-paso-profundiza",
  components: { MddPasoSubtitulo },
  props: ["lectio", "step", "num", "control"],
  data() {
    return {
      showHelp3: false
    };
  },
  computed: {
    t() {
      return this.$store.getters["app/trad/activa"];
    },
    showPray() {
      return this.num === this.control;
    }
  }
};
</script>
